var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTags(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "tags_a",
    d: "M0 .415h24V24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.415)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "tags_b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tags_a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.966 1.414H1.5c-.275 0-.5.225-.5.5l.007 6.493c.027.491.233.988.58 1.374L14.66 22.854a.5.5 0 0 0 .708 0l7.425-7.424L9.347 1.975a2.271 2.271 0 0 0-1.381-.56M15.015 24c-.385 0-.77-.146-1.061-.439L.862 10.47a3.305 3.305 0 0 1-.854-2.035L0 1.915c0-.828.673-1.5 1.5-1.5h6.492a3.308 3.308 0 0 1 2.042.834l13.82 13.828a.5.5 0 0 1 0 .707l-7.78 7.777a1.497 1.497 0 0 1-1.06.44",
    mask: "url(#tags_b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.5 4C4.673 4 4 4.673 4 5.5S4.673 7 5.5 7 7 6.327 7 5.5 6.327 4 5.5 4m0 4A2.503 2.503 0 0 1 3 5.5C3 4.122 4.121 3 5.5 3S8 4.122 8 5.5 6.879 8 5.5 8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTags);
export default __webpack_public_path__ + "static/media/tags.f4fcff93dd54838ecd28c96ec2a50cb5.svg";
export { ForwardRef as ReactComponent };